var map = {
	"./freshwater/arapaima/3.jpg": "bdc8",
	"./freshwater/beluga-sturgeon/3.jpg": "01b2",
	"./freshwater/chinook-salmon/3.jpg": "d71a",
	"./freshwater/goldfish/3.jpg": "2903",
	"./freshwater/koi-carp/3.jpg": "b2f9",
	"./freshwater/red-bellied-piranha/3.jpg": "4647",
	"./freshwater/redtail-catfish/3.jpg": "5528",
	"./freshwater/smalltooth-sawfish/3.jpg": "5c25",
	"./ocean/bottlenose-dolphin/3.jpg": "9402",
	"./ocean/box-jellyfish/3.jpg": "d424",
	"./ocean/giant-pacific-octopus/3.jpg": "1c18",
	"./ocean/gray-seal/3.jpg": "782b",
	"./ocean/green-sea-turtle/3.jpg": "5af4",
	"./ocean/humboldt-penguin/3.jpg": "8434d",
	"./ocean/manta-ray/3.jpg": "e187",
	"./ocean/starfish/3.jpg": "2a19",
	"./saltwater/atlantic-tarpon/3.jpg": "966a",
	"./saltwater/butterflyfish/3.jpg": "6194",
	"./saltwater/clownfish/3.jpg": "ca79",
	"./saltwater/emperor-angelfish/3.jpg": "0520",
	"./saltwater/hippo-tang/3.jpg": "d919",
	"./saltwater/longhorn-cowfish/3.jpg": "b376",
	"./saltwater/red-lionfish/3.jpg": "ee30",
	"./saltwater/yellow-surgeonfish/3.jpg": "486c",
	"./shark/blacktip-shark/3.jpg": "eb7c",
	"./shark/bull-shark/3.jpg": "6b81",
	"./shark/nurse-shark/3.jpg": "6308",
	"./shark/oceanic-whitetip-shark/3.jpg": "222d",
	"./shark/pelagic-thresher-shark/3.jpg": "85fa",
	"./shark/scalloped-hammerhead-shark/3.jpg": "e0b4",
	"./shark/whale-shark/3.jpg": "186f",
	"./shark/zebra-shark/3.jpg": "eec7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0048";